<template>
  <div>
    <div v-if="auditLogLoader">
      <v-skeleton-loader
        v-for="(n, key) in 2"
        :key="key"
        class="mx-auto"
        type="list-item-two-line"
      ></v-skeleton-loader>
    </div>
    <div id="log" class='title fontcolor'><!-- {{entityTitle}} Adoption Activity --></div>
      <div v-if="activityLogList.length > 0" class="admActivityLogWrapper">
        <v-timeline dense>
          <v-timeline-item v-for="item in activityLogList" :key="item.id" small :color= primaryColor >
            <v-card outlined >
              <v-card-text style="color:#000" >
                {{item.date}}:
                <span class="font-weight-medium">{{item.bookYearTitle}}</span>
                <span v-if="item.action === 'insert'" > added as</span>
                <span v-if="item.action === 'update' && item.status !== ''" > changed to</span>
                <span class="font-weight-medium"> {{item.status}}</span>
                <span v-if="item.effectiveDate"> effective from </span>
                <span v-if="item.effectiveDate" class="font-weight-medium"> {{item.effectiveDate}}</span>
                <span v-if="(item.effectiveDate && item.status === '') || item.isCountryAdoption" > updated</span>
                <span> by {{item.userName}}</span>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </div>
      <div class="mb-6" style="color: rgba(0, 0, 0, 0.38); text-align: center;font-size: 0.875rem;" v-else>
        No activity found!
      </div>
      <v-spacer></v-spacer>
  </div>
</template>

<script>

export default {
  name: 'AdminActivityByEntity',
  data: () => ({
    'primaryColor': '#0B5940',
    activityLogs: [],
    auditLogLoader: true
  }),
  props: {
    entityTitle: {
      Type: String
    },
    adoptionLevel: {
      Type: Number
    },
    name: {
      Type: String
    }
  },
  mounted () {
    let adoptionLevel = this.adoptionLevel
    let adoptionLevelFor = this.$globalFromValidation.paramIsInNumFormat(this.$route.params.id)
    let adoptionName = this.adoptionName
    this.$store.commit('AdoptionModule/setAdoptionData', { adoptionLevel, adoptionLevelFor, adoptionName })
    this.initialize()
  },
  computed: {
    activityLogList () {
      return this.activityLogs
    },
    adoptionLvlFor () {
      return this.adoptionLevelFor
    },
    id () {
      return this.adoptionLevel
    },
    adoptionName () {
      return this.name
    }
  },
  methods: {
    initialize () {
      new Promise((resolve, reject) => {
        this.$store.dispatch('AdoptionModule/getMappedAdoptionList', {
          resolve,
          reject
        })
      })
        .then(responseData => {
          if (responseData.auditList.length > 0) {
            this.activityLogs = responseData.auditList
          } else {
            this.activityLogs = ''
          }
          this.auditLogLoader = false
        })
        .catch(response => {
          this.auditLogLoader = false
        })
    }
  }
}
</script>
